export interface AllocationSummary {
    totalValue: number;
    totalAmount: number;
}
